import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles(theme => ({
    container: {
        backgroundColor: theme.colors.dark.dark1,
        padding: '0 16px 60px 16px',
        '& p': {
            marginBottom: '0',
        },
        '@media (min-width: 768px)': {
            width: '768px',
        },
    },
    headline: {
        ...theme.typographyPresets.titleSmallBold,
        ...theme.fontColors.light,
        paddingTop: '50px',
        marginBottom: '48px',
    },
    headlineDesc: {
        ...theme.typographyPresets.titleSmallLight,
        ...theme.fontColors.grey,
        fontSize: '14px',
        letterSpacing: 'normal',
        fontWeight: '600',
        marginTop: '36px',
    },
    disclaimer: {
        ...theme.typographyPresets.titleSmallLight,
        ...theme.fontColors.grey,
        fontSize: '12px',
        letterSpacing: 'normal',
        fontWeight: '500',
        marginTop: '48px',
    },
    formInline: {
        ...theme.forms.inline.form,
    },
    formCtrlInline: {
        ...theme.forms.inline.formCtrl,
    },
}))
